import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialTiktok = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="social-tiktok"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.7 7.266a5.283 5.283 0 01-3.192-1.067 5.295 5.295 0 01-2.11-4.183h-3.424v9.355l-.004 5.124a3.099 3.099 0 01-3.279 3.092 3.086 3.086 0 01-1.417-.434 3.098 3.098 0 01-1.515-2.611 3.101 3.101 0 014.082-2.988v-3.476a6.735 6.735 0 00-.987-.073 6.565 6.565 0 00-4.933 2.207 6.422 6.422 0 00-1.62 3.874 6.414 6.414 0 001.91 4.997 6.566 6.566 0 004.643 1.9 6.544 6.544 0 004.643-1.9 6.41 6.41 0 001.923-4.561l-.018-7.652a8.654 8.654 0 005.308 1.804V7.265c.001.001-.009.001-.01.001z" />
    </svg>
  );
};
/* eslint-enable max-len */

SocialTiktok.defaultProps = {
  className: null,
};

SocialTiktok.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialTiktok;
